export enum LogLevel {
    NONE = 0,
    ERROR = 1,
    WARN = 2,
    INFO = 3,
    DEBUG = 4,
}

class Logger {
    private level: LogLevel = LogLevel.INFO;

    constructor() {
    }

    setLevel(level: LogLevel) {
        this.level = level;
    }

    getLevel(): LogLevel {
        return this.level;
    }
    
    private log(level: LogLevel, ...args: any[]) {
        if (this.level >= level) {
            const timestamp = new Date().toISOString();
            const levelName = LogLevel[level];
            switch (level) {
                case LogLevel.ERROR:
                    console.error(timestamp, `[${levelName}]`, ...args);
                    break;
                case LogLevel.WARN:
                    console.warn(timestamp, `[${levelName}]`, ...args);
                    break;
                case LogLevel.INFO:
                    console.info(timestamp, `[${levelName}]`, ...args);
                    break;
                case LogLevel.DEBUG:
                    console.log(timestamp, `[${levelName}]`, ...args);
                    break;
            }
        }
    }

    error = (...args: any[]) => this.log(LogLevel.ERROR, ...args);
    warn = (...args: any[]) => this.log(LogLevel.WARN, ...args);
    info = (...args: any[]) => this.log(LogLevel.INFO, ...args);
    debug = (...args: any[]) => this.log(LogLevel.DEBUG, ...args);
}

export const logger = new Logger();